import React, {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import SubTitle from "../../components/SubTitle";
import DangerEvaluationForm from "./DangerEvaluationForm";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import * as dangerEvaluationApi from "../../api/permissionApi/dangerEvaluationApi";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";
import {useGetItemQuery, useUpdateMutation} from "../../hooks/useQueryHooks";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {
  WPDangerEvaluation,
  initializeDangerEvaluation,
} from "../../models/serverModels/permission/WPDangerEvaluation";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import {useQueryClient} from "react-query";
import MWProgress from "../../components/MWProgress";
import {FormSection} from "../../styledComponents/StyledCreateForm";

const UpdateDangerEvaluation = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const location = useLocation();

  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data: dangerEvaluation, isLoading: isGetLoading} = useGetItemQuery<
    ResponseItem<WPDangerEvaluation>
  >({
    key: ["dangerEvaluation", id],
    api: () => dangerEvaluationApi.getItem({token: tokenState, id: parseInt(id!)}),
  });

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<WPDangerEvaluation>,
    Params.Update<WPDangerEvaluation>
  >({
    api: dangerEvaluationApi.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate(`/Permission/CheckPermission/${id}`);
        queryClient.invalidateQueries(["dangerEvaluation", id]);
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });

  const methods = useForm<WPDangerEvaluation>({
    defaultValues: dangerEvaluation?.item || initializeDangerEvaluation(),
  });

  const {reset} = methods;

  useEffect(() => {
    reset(dangerEvaluation?.item);
  }, [dangerEvaluation?.item, reset]);

  const onSubmit: SubmitHandler<WPDangerEvaluation> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...initializeDangerEvaluation(), ...data},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle
        subTitle="작업위험성평가 수정
"
      />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <DangerEvaluationForm captionColor="#01579B" />
            <ConfirmButtonGroup
              link="/Permission/List"
              cancelText="취소"
              confirmText="수정 및 세부항목 이동"
            />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateDangerEvaluation;
